module.exports = __webpack_public_path__ + "img/1-5-p2.7fcb87f5.svg";